import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage)

let token = null
let authToken =  Vue.localStorage.get('token')
if (authToken) {
    token = authToken
}

let headers = {
    'Content-Type': 'application/json',
    'Authorization': token,
    'Platform': 'mac'
}

export default headers